import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import styles from './styles.module.scss';
import {
  Box, Card, CardContent,
  TextField, InputAdornment, SvgIcon, Button,
  Grid
} from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Loader from '@components/Loader';
import { useNavigate } from 'react-router-dom';
import { getApiReq } from 'src/utils/ApiHandlers';
import { useDispatch } from 'react-redux';
import { showToast } from '@redux/action/index';
import { cutString } from 'src/utils/BasicRequest';

export default function Agency() {
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState('')
  const navigate = useNavigate();
  const [agencyList, setAgencyList] = useState([])
  const dispatch = useDispatch();

  const getAgencyList = () => {
    setIsLoading(true);
    getApiReq(`/admin/get-agency?search=${search}`)
      .then(res => {
        if (res) {
          setAgencyList(res.data)
          setIsLoading(false);
        }
        else {
          dispatch(showToast({ message: res.error, type: 'error' }))
          setIsLoading(false);
        }
      }).catch(e => { console.log(e) })
  };

  useEffect(() => {
    getAgencyList();
  }, [search]);

  return (
    <React.Fragment>
      <TableContainer component={Paper} >
        <Typography className={styles.heading}>Agency</Typography>
        <p className={styles.paragraph}>A series of games or contests that make up a single unit of competition.</p>
        <Box mt={3}>
          <Card>
            <CardContent>
              <Grid container spacing={3} alignItems='center'>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                          >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    placeholder="Search"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={4} align="right">
                  <Button onClick={() => navigate('/create-agency')} size="large" variant="contained" startIcon={<AddCircleIcon />}>Create Agency</Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
        {/* <InfiniteScroll
          dataLength={length}
          next={getMoreList}
          hasMore={true}
          style={{ overflow: 'none' }}
        > */}

        <Table className='table' sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={styles.tabletitle}>#</TableCell>
              <TableCell className={styles.tabletitle} align="center">Agency Name</TableCell>
              <TableCell className={styles.tabletitle} align="center">Year</TableCell>
              <TableCell className={styles.tabletitle} align="center">Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {agencyList?.map((item, index) => (
              <TableRow
                className={styles.tableRow}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell key={index} >{index + 1}</TableCell>
                <TableCell className={styles.dataView} align="center" >{item.agencyName}</TableCell>
                <TableCell className={styles.dataView} align="center" >{item.year}</TableCell>
                <TableCell className={styles.dataView} align="center" >{cutString(item.description, 80)}</TableCell>
              </TableRow>
            ))}

          </TableBody>
        </Table>

        {agencyList?.length < 1 && <Box align={'center'} w='100%' p={5} >
          <Typography variant="body1" textAlign="center" color="textSecondary">Data not Available</Typography>
        </Box>}

        {/* </InfiniteScroll> */}
        <Loader isLoading={isLoading} />
      </TableContainer >
    </React.Fragment >
  );
}
